import PropTypes from 'prop-types'
import React from 'react'
import WarningIcon from '@mui/icons-material/Warning'
import { red } from '@mui/material/colors'

class WarningLabel extends React.Component {
    static propTypes = {
        message: PropTypes.string,
    }
    static defaultProps = {
        message: 'Something went wrong',
    }

    render() {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <WarningIcon htmlColor={red[500]} />
                <p
                    style={{color: red[500]}}>
                    {this.props.message}
                </p>
            </div>
        )
    }
}

export default WarningLabel
